const a = {
  s0289cd9e4bcf84c5: "Livello volume",
  s061cc20e3432dead: "Sospendi",
  s0622a6e6cb77254b: "Trascrizione",
  s080d032fc1b87b3f: "Descrizione audio",
  s08b06007b5567108: "di",
  s08e6bd98452e6bb9: "Audio",
  s1b4a36fce2456660: "Famiglia di caratteri",
  s1fa5be5a4f5d0f04: "Informale",
  s23537b5c9e7af982: "Sottotitoli",
  s24221a89168e9d21: "Dimensioni carattere",
  s255857544a9d5ec0: "Reimposta",
  s25a858f0257e2879: "Menu Sottotitoli",
  s2df075aface0dab8: "Condividi",
  s2f5d5d2d1f92de26: "Scarica video",
  s302cbb19bf9a174a: "Disattiva",
  s308604b3ae13fbb5: "In riproduzione",
  s344ea8f4939cdc98: "Colore",
  s3687049d1af562c4: "Copia",
  s36b979e4de5152b3: "Collegamento copiato",
  s37a9e8aec5713460: "Altro",
  s3ca1bdfa8785f808: "Proportional Sans Serif",
  s41faaf3b4e182cc6: "Verifica età richiesta per accedere a questo contenuto.",
  s49f06dca0feeb2f3: "Uniforme",
  s4b023aafbd8d5ac8: "Condividi questo video",
  s4b10acae683d2978: "Schermo intero",
  s500caa88d20458d3: "Non puoi accedere a questo contenuto",
  s5267658ceae3230f: "Condividi questo video",
  s5c5db15dfc3a5376: "Frequenza di riproduzione",
  s5e3cb80d43a34044: "Nero",
  s5e8250fb85d64c23: "Chiudi",
  s669b18c6d2d9c95b: "Nessuno",
  s66d852e3c020e79e: "Opaco",
  s6a3bf589eaf72169: "Monospace Serif",
  s6baf78886c99db89: "Giallo",
  s6f59e9b81c5a47e0: "Ombreggiatura",
  s711d047dea682c1a: "Traccia audio",
  s7d148a08796094d2: "Errore di riproduzione",
  s81a19821f3e4a3d2: "Riproduci",
  s827bc70ebcb7bbc6: "Monospace Sans Serif",
  s85186a61e0d55bac: "Video",
  s889413eb7198ea01: "opzione per disattivare i sottotitoli",
  s8e408592fd4ae43a: "Stile bordo testo",
  s8e985aeeca6a8166: "Bianco",
  s8eafb22ebdc7e668: "Magenta",
  s9559a51a63cbb5fd: "Maiuscoletto",
  s95bc8722b2708f8b: "In pausa",
  s973b83fb67a5865d: "Scarica trascrizione",
  s9b3c2f9cc32d565a: "Ciano",
  s9c356016f81585f6: "Colore di sfondo",
  s9d8b8aa2b404c2c8: "Impostazioni",
  s9fbd543f2179c1ec: "Menu Audio",
  sa000eaf7092088c3: "Indicatore di stato",
  sa6f2645578b2d2bc: "Anno",
  sa9011e79e3ca2d18: "Incassato",
  saf9b398ab363c174: "Immetti la tua data di nascita",
  sb3d4f79d9d8b71e5: "Invia",
  sb47daaf9e1c4a905: "Mese",
  sb9f16a5f9c29f41e: "Siamo spiacenti. Si è verificato un problema.",
  sba64d8954d027206: "Opacità",
  sc07837c309cc699b: "Attiva audio",
  scd105819b5a10243: "Riproduci",
  sce836928a17d96ed: "Colore testo",
  scf00d78fd5953f1c: "Verde",
  sd1246235faaa3191: "È stata applicata una restrizione di età dovuta ai temi per soli adulti o ai requisiti legali volti a proteggere il pubblico più giovane.",
  sd3386a2ef42e80b9: "Scarica",
  sd8d4b1b613d28990: "Corsivo",
  sdb02f53e62c1da05: "In rilievo",
  sdb73788b3c975f16: "Auto",
  se0955919920ee87d: "Giorno",
  se0f67eae944f8f94: "Disattiva audio",
  se73c59cc10f48c12: "Social",
  secf3d3a7c1693e2d: "Blu",
  sed31876562d94652: "Impostazioni sottotitolo",
  sf113fa256db9617b: "Completato",
  sf675f879b1c892c6: "Qualità",
  sfc24a457269b13d4: "Dispositivo di scorrimento volume",
  sfcb817633bf70e1b: "Proportional Serif"
};
export {
  a as templates
};
